export const convertMetersToFeet = (heightInMeters: number): number => heightInMeters * 3.28084;

export const convertHertzToSeconds = (valueInHertz: number): number => 1 / valueInHertz;

export const convertMetersPerSecondToKnots = (valueInMS: number): number => valueInMS * 1.94384;

export const convertMetersPerSecondToKPH = (valueInMS: number): number => valueInMS * 3.6;

export const convertMetersPerSecondToMPH = (valueInMS: number): number => valueInMS * 2.23694;

export const convertKelvinToCelcius = (valueInKelvin: number): number => valueInKelvin - 273.15;

export const convertKelvinToFahrenheit = (valueInKelvin: number): number =>
  (valueInKelvin - 273.15) * (9 / 5) + 32;

export const convertPrecipitationDataLayerValueToMMPerHour = (value: number): number =>
  (Math.exp(value / 64.855) - 1) * 0.36;

export const convertMMtoInches = (value: number): number => value * 0.0393701;

export const convertKnotsToMph = (knots: number): number => knots * 1.150779;

export const convertKphToMph = (kph: number): number => kph / 1.609344;
